'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThreads = undefined;

var _reselect = require('reselect');

var _getters = require('conversations-async-data/async-data/operators/getters');

var _getThreadsAsyncData = require('./getThreadsAsyncData');

var getThreads = exports.getThreads = (0, _reselect.createSelector)([_getThreadsAsyncData.getThreadsAsyncData], function (threads) {
  return (0, _getters.getData)(threads);
});